import React, { useEffect } from "react";
import Menu from "../components/menu";
import ReactGA from "react-ga4";

const LOCALES = {
  titre: {
    label: {
      fr: "Remerciements",
      en: "Acknowledgments",
    },
  },
};

const PAGE = "remerciements";

const Remerciements = ({ lang }) => {
  useEffect(() => {
    //Google analytics 4
    ReactGA.event("page_view", {
      page_title: LOCALES.titre.label[lang],
    });
  }, [lang]);
  return (
    <div className="page page-remerciement">
      <Menu lang={lang} activePage={PAGE} />
      <div id="contenu_centre">
        <h1>{LOCALES.titre.label[lang]}</h1>
        {getContent(lang)}
      </div>
    </div>
  );
};

function getContent(lang) {
  let extLinkTitle =
    lang === "fr"
      ? "Ce lien ouvrira une nouvelle fenêtre"
      : "This link will open a new window";
  if (lang === "en") {
    return (
      <div className="texte_petit">
        <p>
          The Institut de la statistique du Québec (ISQ) would like to thank
          Industry Canada for its contribution to the International Trade Data
          Online (ITDO) tool, which allows the ISQ to make available, online,
          more information on Québec’s and Canada’s international trade,
          therefore reaching a larger number of users.
        </p>
        <p>
          In addition, a large part of the content of the ITDO comes from
          Industry Canada’s{" "}
          <a
            title={extLinkTitle}
            href="https://www.ic.gc.ca/eic/site/tdo-dcd.nsf/eng/home"
            target="_blank"
            rel="noopener noreferrer"
            className="lien-externe"
          >
            Trade Data Online
          </a>{" "}
          site. That content has been modified to meet the needs of the ISQ’s
          ITDO tool.
        </p>
      </div>
    );
  } else {
    return (
      <div className="texte_petit">
        <p>
          L'Institut de la statistique du Québec (ISQ) remercie Industrie Canada
          pour son apport à la réalisation de l'outil Commerce international en
          ligne (CIEL). Grâce à cette contribution, l’ISQ peut diffuser, sur
          Internet, plus d'information sur le commerce international du Québec
          et du Canada et rejoindre ainsi un plus grand nombre d'utilisateurs.{" "}
        </p>
        <p>
          Le Commerce international en ligne utilise une grande partie des
          éléments du site{" "}
          <a
            title={extLinkTitle}
            href="https://www.ic.gc.ca/eic/site/tdo-dcd.nsf/fra/accueil"
            target="_blank"
            rel="noopener noreferrer"
            className="lien-externe"
          >
            Données sur le commerce en direct (DCD)
          </a>{" "}
          d'Industrie Canada. Le contenu a été modifié afin de répondre aux
          besoins de l'outil CIEL de l’ISQ.
        </p>
      </div>
    );
  }
}

export default Remerciements;
